enum IModalActions {
  ToggleModal,
  OpenModal,
  CloseModal,
  UpdateModal
}

type IModalAction =
  | {
      type: IModalActions.CloseModal
    }
  | {
      type: Exclude<IModalActions, IModalActions.CloseModal>
      data: IModalState
    }

type IModalState = {
  isModalForceClose?: boolean
  isModalOpen?: boolean
  modalType?: ModalTypes | null
  modalData?: any
}

enum ModalTypes {
  LoginRegister = "LoginRegister",
  VideoPopup = "VideoPopup",
  LoginModal = "LoginModal",
  ConnectModal = "ConnectModal",
  ConnectModalV2 = "ConnectModalV2",
  ConnectModalMobileNumber= "ConnectModalMobileNumber",
  ConnectModalMba = "ConnectModalMba",
  ConnectModalPartner = "ConnectModalPartner",
  ConnectModalScholarship = "ConnectModalScholarship",
  DownloadBrochure = "DownloadBrochure",
  DownloadBrochureLP = "DownloadBrochureLP",
  PreDegreeModal = "PreDegreeModal",
  CallUsModal = "CallUsModal",
  CallUsModal_V2="CallUsModalV2",
  CallingSticky_Modal="CallingSticky_Modal",
  emiModal = "emiModal",
  RegistrationForm = "RegistrationForm",
  ConnectModalLP = "ConnectModalLP",
  LandingPageConnectModalTempleteOne= "LandingPageConnectModalTempleteOne", 
  ConnectModalFormSponsoredCourses= "ConnectModalFormSponsoredCourses",
  ShareIcon="ShareIcon",
  TestimonialModal="Testimonial",
  ScholarshipTest="ScholarshipTest",
  ConnectModalFAQ="ConnectModalFAQ",
  ConnectModalCalender="ConnectModalCalender",
  ConnectModalVideoCounselling="ConnectModalVideoCounselling",
  ConnectModalVideoCounsellingLandingPage="ConnectModalVideoCounsellingLandingPage",
  ConnectModal30Sec="ConnectModal30Sec",
  scholarshipRFI="scholarshipRFI",
  ConnectModalAONSAT="ConnectModalAONSAT",
  ConnectModalB2I="ConnectModalB2I",
  BrandModal="BrandModal",
  WebinarModal="WebinarModal",
  ProfessorModal="ProfessorModal",

}

type LoginTypes = {
  withEmail: boolean
  withOTP: boolean
  forgetPass: boolean
}

export { IModalActions, ModalTypes }
export type { IModalAction, IModalState, LoginTypes }

